import React, { useContext } from "react";
import { Button, Icon } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import NewPackageForm from "./NewPackageForm";
import ListPackages from "./ListPackages";

const DashboardPackage = () => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;

  return (
    <div className="configurationContent">
      <Button
        onClick={() => openModal(<NewPackageForm />, "Crear paquete")}
        color="blue"
      >
        <Icon name="plus circle" /> Agregar Paquete
      </Button>
      <br />
      <br />
      {<ListPackages />}
    </div>
  );
};

export default DashboardPackage;
